import { Scene, Object3D, Vector3 } from "three";
import Loader from "../Loader";

class Tent {
    public model: Object3D | null;

    public position: Vector3;

    constructor(scene: Scene, loader: Loader) {
        this.model = null;
        loader.loadModel(
            `${process.env.ASSET_URL}/models/tent.dae`,
            (model: Object3D) => {
                scene.add(model);
                this.model = model;
                this.update();
            }
        );
        this.position = new Vector3();
    }

    public update(): void {
        const { position, model } = this;
        if (model !== null) {
            model.position.set(position.x, position.y, position.z);
        }
    }
}

export default Tent;
